import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: '品牌故事'
    }
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('@/views/Product.vue'),
    meta: {
      title: '产品系列'
    }
  },
  {
    path: '/productDetail/:id',
    name: 'ProductDetail',
    component: () => import('@/views/components/ProductDetail.vue'),
    props: true
  },
  {
    path: '/business',
    name: 'Business',
    component: () => import('@/views/Business.vue'),
    meta: {
      title: '品牌加盟'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
    meta: {
      title: '联系我们'
    }
  },
  {
    path: '/article',
    name: 'Article',
    component: () => import('@/views/Article.vue'),
    meta: {
      title: '最新资讯'
    }
  },
  {
    path: '/articleDetail/:id',
    name: 'ArticleDetail',
    component: () => import('@/views/components/ArticleDetail.vue'),
    props: true
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router

export function resetRouter() {
  router.push({ path: '/home' })
}
